import { SxProps } from '@mui/material';

export const currentStoreLocatorSX: SxProps = {
	display: 'flex',
	gap: 0.625,
	pl: '28px',
};
